import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import axios from "axios";
import { Button, Table } from "semantic-ui-react";
import { getAuthHttpHeaders } from "../auth";
import { formatDateTimeFromApi } from "../utils/dateTime";
import { ExchangeType } from "../constants";

const DEF_LIMIT = 25;

@inject("store")
@observer
class SuspiciousCurrencies extends Component {
  state = {
    suspiciousCurrencies: undefined,
    limit: DEF_LIMIT,
  };

  componentDidMount() {
    this.load();
  }

  componentWillUnmount() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
  }

  load = async () => {
    this.setState({ loading: true });

    try {
      let axiosRequest = axios.create({
        baseURL: "api",
        headers: {
          Accept: "application/json",
          ...getAuthHttpHeaders(),
        },
      });

      let response = await axiosRequest.get("exchangeAccount/suspiciousCurrencies/list");
      this.setState({ suspiciousCurrencies: response.data });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { suspiciousCurrencies } = this.state;
    const {
      store: { zoneId },
    } = this.props;

    return (
      <div>
        <h1>Suspicious Currencies</h1>
        <div style={{ overflowY: "auto" }}>
          <Table unstackable collapsing>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>ID</Table.HeaderCell>
                <Table.HeaderCell>Created At</Table.HeaderCell>
                {Object.values(ExchangeType).map(exchangeType => (
                  <Table.HeaderCell key={exchangeType}>{exchangeType}</Table.HeaderCell>
                ))}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {suspiciousCurrencies &&
                suspiciousCurrencies.filter((sc, i) => i < this.state.limit).map(sc => {
                  const data = JSON.parse(sc.data);
                  return (
                    <Table.Row key={sc.id} style={{ whiteSpace: "nowrap" }}>
                      <Table.Cell title={sc.id}>{sc.id.substring(0, 4)}</Table.Cell>
                      <Table.Cell>{formatDateTimeFromApi(sc.createdAt, zoneId)}</Table.Cell>
                      {Object.values(ExchangeType).map(exchangeType => (
                        <Table.Cell key={exchangeType}>
                          {Object.keys(data[exchangeType]).map(url => (
                            <div key={url}>
                              <span style={{ color: "gray" }}>{url}</span>
                              <br />
                              {data[exchangeType][url].join(", ")}
                            </div>
                          ))}
                        </Table.Cell>
                      ))}
                    </Table.Row>
                  );
                })}
            </Table.Body>
          </Table>
        </div>
        {suspiciousCurrencies != null &&
          suspiciousCurrencies.length > this.state.limit && (
            <Button icon="angle down" onClick={() => this.setState({ limit: this.state.limit + DEF_LIMIT })} />
          )}
        {suspiciousCurrencies != null &&
          suspiciousCurrencies.length > this.state.limit && (
            <Button icon="angle double down" onClick={() => this.setState({ limit: Number.MAX_SAFE_INTEGER })} />
          )}
        {suspiciousCurrencies != null &&
          this.state.limit > DEF_LIMIT && (
            <Button icon="angle double up" onClick={() => this.setState({ limit: DEF_LIMIT })} />
          )}
        <Button.Group>
          <Button content="Refresh" icon="refresh" onClick={this.load} loading={this.state.loading} />
        </Button.Group>
      </div>
    );
  }
}

export default SuspiciousCurrencies;



// WEBPACK FOOTER //
// ./src/exchangeAccounts/SuspiciousCurrencies.js